import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5261">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5262">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5263">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5264">
            <ArrowLeft className="w-4 h-4" data-id="element-5265" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5266">NOIZA</div>
          <div className="w-20" data-id="element-5267" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5268">
        <div className="mb-12" data-id="element-5269">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5270">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5271" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5272">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5273">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5274">
          <section data-id="element-5275">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5276">
              <span className="text-[#006847]" data-id="element-5277">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5278">
              <p data-id="element-5279">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5280">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5281">
                <li data-id="element-5282">Haber leído íntegramente este documento</li>
                <li data-id="element-5283">Comprender su contenido en su totalidad</li>
                <li data-id="element-5284">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5285">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5286">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5287">
              <span className="text-[#006847]" data-id="element-5288">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5289">
              <p data-id="element-5290">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5291">
                <li data-id="element-5292">Software como servicio (SaaS)</li>
                <li data-id="element-5293">Marketplace digital gastronómico</li>
                <li data-id="element-5294">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5295">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5296">
                <li data-id="element-5297">Mostrar su menú digital</li>
                <li data-id="element-5298">Recibir pedidos de clientes</li>
                <li data-id="element-5299">Gestionar su operación interna</li>
                <li data-id="element-5300">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5301">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5302">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5303">
              <span className="text-[#006847]" data-id="element-5304">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5305">
              <p data-id="element-5306">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5307">
                <li data-id="element-5308">No es proveedor de alimentos</li>
                <li data-id="element-5309">No participa en la preparación de productos</li>
                <li data-id="element-5310">No manipula alimentos en ningún momento</li>
                <li data-id="element-5311">No realiza entregas ni logística</li>
                <li data-id="element-5312">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5313">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5314">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5315">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5316">
              <span className="text-[#006847]" data-id="element-5317">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5318">
              <p data-id="element-5319">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5320">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5321">
                <li data-id="element-5322">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5323">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5324">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5325">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5326">
                <li data-id="element-5327">Precios</li>
                <li data-id="element-5328">Menú</li>
                <li data-id="element-5329">Horarios</li>
                <li data-id="element-5330">Métodos de pago</li>
                <li data-id="element-5331">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5332">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5333">
              <span className="text-[#006847]" data-id="element-5334">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5335">
              <div data-id="element-5336">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5337">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5338">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5339">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5340">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5341">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5342">
                  <li data-id="element-5343">Calidad de los alimentos</li>
                  <li data-id="element-5344">Estado, frescura o preparación</li>
                  <li data-id="element-5345">Ingredientes utilizados</li>
                  <li data-id="element-5346">Contaminación cruzada</li>
                  <li data-id="element-5347">Problemas de higiene o salubridad</li>
                  <li data-id="element-5348">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5349">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5350">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5351">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5352">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5353">
                  <li data-id="element-5354">Retrasos en la entrega</li>
                  <li data-id="element-5355">Pérdida de pedidos</li>
                  <li data-id="element-5356">Entregas incompletas</li>
                  <li data-id="element-5357">Errores en dirección</li>
                  <li data-id="element-5358">Conducta de repartidores</li>
                  <li data-id="element-5359">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5360">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5361">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5362">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5363">
                  <li data-id="element-5364">Recepción de pagos</li>
                  <li data-id="element-5365">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5366">Manejo de efectivo</li>
                  <li data-id="element-5367">Confirmación de pagos</li>
                  <li data-id="element-5368">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5369">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5370">
                  <li data-id="element-5371">Pagos no recibidos</li>
                  <li data-id="element-5372">Comprobantes falsos</li>
                  <li data-id="element-5373">Errores en montos</li>
                  <li data-id="element-5374">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5375">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5376">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5377">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5378">
                  <li data-id="element-5379">Reclamos de clientes</li>
                  <li data-id="element-5380">Reembolsos</li>
                  <li data-id="element-5381">Cancelaciones</li>
                  <li data-id="element-5382">Disputas</li>
                  <li data-id="element-5383">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5384">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5385">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5386">
              <span className="text-[#006847]" data-id="element-5387">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5388">
              <p data-id="element-5389">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5390">
                <li data-id="element-5391">Responsable</li>
                <li data-id="element-5392">Legal</li>
                <li data-id="element-5393">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5394">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5395">
                <li data-id="element-5396">Publicar información falsa</li>
                <li data-id="element-5397">Manipular precios de forma engañosa</li>
                <li data-id="element-5398">Simular disponibilidad inexistente</li>
                <li data-id="element-5399">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5400">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5401">
              <span className="text-[#006847]" data-id="element-5402">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5403">
              <p data-id="element-5404">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5405">
                <li data-id="element-5406">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5407">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5408">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5409">
                <li data-id="element-5410">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5411">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5412">
                    <li data-id="element-5413">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5414">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5415">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5416">
              <span className="text-[#006847]" data-id="element-5417">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5418">
              <p data-id="element-5419">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5420">
                <li data-id="element-5421">Menú digital</li>
                <li data-id="element-5422">Gestión de pedidos</li>
                <li data-id="element-5423">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5424">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5425">
                  <p className="font-medium text-white mb-2" data-id="element-5426">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5427">
                    <li data-id="element-5428">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5429">
                  <p className="font-medium text-white mb-2" data-id="element-5430">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5431">
                    <li data-id="element-5432">Propiedad del software</li>
                    <li data-id="element-5433">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5434">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5435">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5436">
              <span className="text-[#006847]" data-id="element-5437">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5438">
              <p data-id="element-5439">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5440">
                <li data-id="element-5441">Disponibilidad continua</li>
                <li data-id="element-5442">Funcionamiento sin interrupciones</li>
                <li data-id="element-5443">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5444">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5445">
                <li data-id="element-5446">Fallas técnicas</li>
                <li data-id="element-5447">Actualizaciones</li>
                <li data-id="element-5448">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5449">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5450">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5451">
              <span className="text-[#006847]" data-id="element-5452">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5453">
              <p data-id="element-5454">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5455">
                <li data-id="element-5456">No está garantizada permanentemente</li>
                <li data-id="element-5457">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5458">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5459">
                <li data-id="element-5460">Destacar o no restaurantes</li>
                <li data-id="element-5461">Modificar posiciones</li>
                <li data-id="element-5462">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5463">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5464">
              <span className="text-[#006847]" data-id="element-5465">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5466">
              <p data-id="element-5467">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5468">
                <li data-id="element-5469">Cumplir con los pagos acordados</li>
                <li data-id="element-5470">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5471">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5472">
                <li data-id="element-5473">Suspender el servicio</li>
                <li data-id="element-5474">Limitar funcionalidades</li>
                <li data-id="element-5475">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5476">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5477">
              <span className="text-[#006847]" data-id="element-5478">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5479">
              <p data-id="element-5480">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5481">
                <li data-id="element-5482">Incumplimiento de términos</li>
                <li data-id="element-5483">Uso indebido</li>
                <li data-id="element-5484">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5485">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5486">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5487">
              <span className="text-[#006847]" data-id="element-5488">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5489">
              <p data-id="element-5490">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5491">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5492">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5493">
              <span className="text-[#006847]" data-id="element-5494">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5495">
              <p data-id="element-5496">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5497">
                <li data-id="element-5498">Pérdidas económicas</li>
                <li data-id="element-5499">Daños indirectos</li>
                <li data-id="element-5500">Lucro cesante</li>
                <li data-id="element-5501">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5502">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5503">
              <span className="text-[#006847]" data-id="element-5504">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5505">
              <p data-id="element-5506">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5507">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5508">
              <span className="text-[#006847]" data-id="element-5509">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5510">
              <p className="font-medium" data-id="element-5511">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5512">
                <li data-id="element-5513">Ha leído este documento completo</li>
                <li data-id="element-5514">Comprende su alcance</li>
                <li data-id="element-5515">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}